var _rect, _circle, _path, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDeclined = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 30,
    className: "svg-declined",
    viewBox: "0 0 44 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 42,
    height: 28,
    rx: 4,
    stroke: "#8F27C7",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.9137,
    cy: 10.0436,
    r: 3.30435,
    stroke: "#8F27C7",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9962 21.6969C6.77178 18.5982 9.57606 16.3042 12.9136 16.3042C16.2512 16.3042 19.0555 18.5982 19.8311 21.6969C19.8755 21.8744 19.8313 22.0291 19.7039 22.1665C19.5645 22.317 19.3269 22.4346 19.0441 22.4346H6.7832C6.50036 22.4346 6.26281 22.317 6.12334 22.1665C5.996 22.0291 5.95178 21.8744 5.9962 21.6969Z",
    stroke: "#8F27C7",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.3691,
    y: 9.02173,
    width: 11.4348,
    height: 1,
    rx: 0.5,
    stroke: "#8F27C7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25.3691,
    y: 17.0217,
    width: 11.4348,
    height: 1,
    rx: 0.5,
    stroke: "#8F27C7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 25.3691,
    y: 13.0217,
    width: 8.56522,
    height: 1,
    rx: 0.5,
    stroke: "#8F27C7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 25.3691,
    y: 21.0217,
    width: 5.69565,
    height: 1,
    rx: 0.5,
    stroke: "#8F27C7"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDeclined);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Declined.594aeed540d067006db77359831d9501.svg";